<template>
    <div id="NewEnergyDetail">
      <div class="container" v-if="currentImage">
        <h2  style="text-align: center">{{ currentImage.alt }}</h2>
        <img :src="currentImage.src" :alt="currentImage.alt" class="img-responsive" />
        <h2 v-html="currentImage.caption"></h2>
      </div>
      <div v-else>
        <p>没有找到相关的车型信息。</p>
      </div>
    </div>
  </template>
<style scoped>
.container table {
  margin: 100 auto;
}

.container {
padding: 50px 0;
text-align: center;
}

.container > * {
margin-left: auto;
margin-right: auto;
}
/* 自定义样式 */
.container {
    padding: 50px 0;
}
img {
    max-width: 100%;
    height: auto;
    margin-bottom: 20px;
}
/* 容器居中 */
.container table {
  width: 100%;
  max-width: 1366px;
  margin: 0 auto;
  border-collapse: collapse;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  overflow: hidden;
  font-family: Arial, sans-serif;
}

/* 表头样式 */
.container th {
  background-color: #0d6efd; /* 蓝色表头 */
  color: white;
  padding: 15px;
  text-align: left;
  font-weight: bold;
}

/* 表格单元格样式 */
.container td {
  padding: 12px 15px;
  border-bottom: 1px solid #ddd;
  text-align: left;
}

/* 隔行变色 */
.container tr:nth-child(even) {
  background-color: #f9f9f9;
}

</style>
<style>
/* 全局样式 */
/* 容器居中 + 边框 */
.container table {
  width: 100%;
  max-width: 1366px;
  margin: 0 auto;
  border-collapse: collapse;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  overflow: hidden;
  font-family: Arial, sans-serif;
  border: 1px solid #ddd; /* 添加表格整体边框 */
}

/* 表头和单元格边框 */
.container th,
.container td {
  border: 1px solid #ddd; /* 所有单元格加边框 */
  padding: 8px 10px;
  font-size: 12px;
  white-space: nowrap;
  text-align: center;
}

</style>
<script>
export default {
name: 'NewEnergyDetail',
data() {
    return {
    currentImage: null,
    images: [
        {
        src: require('@/assets/img/xinnengyuan1.png'),
        alt: 'J6P 6×4 混合动力牵引',
        caption: ` <table id="container" border="1" cellpadding="0" cellspacing="0"  style="margin: 0 auto;">
                       <thead>
                            <tr>
                                <th>车型描述</th>
                                <th>电机型号</th>
                                <th>后桥</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td data-label="车型描述">J6P 6×4 混合动力牵引</td>
                                <td data-label="电机型号">TZ460XS001A</td>
                                <td data-label="后桥">ф435</td>
                            </tr>
                            </tbody>

                            <thead>
                            <tr>
                                <th>总重</th>
                                <th>马力</th>
                                <th>后桥速比</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td data-label="总重">49</td>
                                <td data-label="马力">177</td>
                                <td data-label="后桥速比">4.111</td>
                            </tr>
                            </tbody>

                            <thead>
                            <tr>
                                <th>平台</th>
                                <th>变速箱</th>
                                <th>轴距</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td data-label="平台">J6P</td>
                                <td data-label="变速箱">CA12TAX230E(AMT）</td>
                                <td data-label="轴距">3450+1350</td>
                            </tr>
                            </tbody>

                            <thead>
                            <tr>
                                <th>车架</th>
                                <th>轮胎</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td data-label="车架">300×80×8</td>
                                <td data-label="轮胎">12R22.5型18层级</td>
                            </tr>
                            </tbody>
                    </table>`,

        id: 1
        },
        {
        src: require('@/assets/img/xinnengyuan2.png'),
        alt: 'J6L 4×2 燃料电池环卫',
        caption: `<table id="container" border="1" cellpadding="0" cellspacing="0"  style="margin: 0 auto;">
                            <thead>
                            <tr>
                                <th>车型描述</th>
                                <th>电机型号</th>
                                <th>后桥</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td data-label="车型描述">J6L 4×2 燃料电池环卫</td>
                                <td data-label="电机型号">绿控TZ370XS-LKM1101电机</td>
                                <td data-label="后桥">ф435</td>
                            </tr>
                            </tbody>

                            <thead>
                            <tr>
                                <th>总重</th>
                                <th>马力</th>
                                <th>后桥速比</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td data-label="总重">18</td>
                                <td data-label="马力">217</td>
                                <td data-label="后桥速比">5.571</td>
                            </tr>
                            </tbody>

                            <thead>
                            <tr>
                                <th>平台</th>
                                <th>变速箱</th>
                                <th>轴距</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td data-label="平台">J6L</td>
                                <td data-label="变速箱">绿控J6S95-AMT</td>
                                <td data-label="轴距">5000</td>
                            </tr>
                            </tbody>

                            <thead>
                            <tr>
                                <th>车架</th>
                                <th>轮胎</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td data-label="车架">237×75×(6.5+4)</td>
                                <td data-label="轮胎">295/80R22.5型</td>
                            </tr>
                            </tbody>
                    </table>`,
        id: 2
        },
        {
        src: require('@/assets/img/xinnengyuan3.png'),
        alt: 'J6L 4×2 新能源充电环卫',
        caption: `<table id="container" border="1" cellpadding="0" cellspacing="0"  style="margin: 0 auto;">
                            <thead>
                            <tr>
                                <th>车型描述</th>
                                <th>电机型号</th>
                                <th>后桥</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td data-label="车型描述">J6L 4×2 新能源充电环卫</td>
                                <td data-label="电机型号">绿控TZ370XS-LKM1101电机</td>
                                <td data-label="后桥">ф435</td>
                            </tr>
                            </tbody>

                            <thead>
                            <tr>
                                <th>总重</th>
                                <th>马力</th>
                                <th>后桥速比</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td data-label="总重">18</td>
                                <td data-label="马力">217</td>
                                <td data-label="后桥速比">5.571</td>
                            </tr>
                            </tbody>

                            <thead>
                            <tr>
                                <th>平台</th>
                                <th>变速箱</th>
                                <th>轴距</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td data-label="平台">J6L</td>
                                <td data-label="变速箱">绿控J6S95-AMT</td>
                                <td data-label="轴距">5600</td>
                            </tr>
                            </tbody>

                            <thead>
                            <tr>
                                <th>车架</th>
                                <th>轮胎</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td data-label="车架">270×75×(7+5)</td>
                                <td data-label="轮胎">295/80R22.5型18层级</td>
                            </tr>
                            </tbody>
                    </table>`,
        id: 3
        },
        {
        src: require('@/assets/img/xinnengyuan4.png'),
        alt: 'J6P 8×4 新能源换电自卸',
        caption: `<table id="container" border="1" cellpadding="0" cellspacing="0"  style="margin: 0 auto;">
                            <thead>
                            <tr>
                                <th>车型描述</th>
                                <th>电机型号</th>
                                <th>后桥</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td data-label="车型描述">J6P 8×4 新能源换电自卸</td>
                                <td data-label="电机型号">中车TZ400XS035电机</td>
                                <td data-label="后桥">ф300轮减桥</td>
                            </tr>
                            </tbody>

                            <thead>
                            <tr>
                                <th>总重</th>
                                <th>马力</th>
                                <th>后桥速比</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td data-label="总重">31</td>
                                <td data-label="马力">489</td>
                                <td data-label="后桥速比">5.921</td>
                            </tr>
                            </tbody>

                            <thead>
                            <tr>
                                <th>平台</th>
                                <th>变速箱</th>
                                <th>轴距</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td data-label="平台" rowspan="3">J6P</td>
                                <td data-label="变速箱" rowspan="3">CA12TAX230E(AMT)</td>
                                <td data-label="轴距">1950+3100+1350</td>
                            </tr>
                            <tr>
                            <td data-label="轴距">1950+3400+1350</td>
                            </tr>
                            <tr>
                            <td data-label="轴距">1950+4000+1350</td>
                            </tr>
                            </tbody>

                            <thead>
                            <tr>
                                <th>车架</th>
                                <th>轮胎</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td data-label="车架">300×80×(8+5)</td>
                                <td data-label="轮胎" rowspan="3">12R22.5型18层级</td>
                            </tr>
                            <tr>
                            <td data-label="轴距">1950+3400+1350</td>
                            </tr>
                            <tr>
                            <td data-label="轴距">1950+4000+1350</td>
                            </tr>
                            </tbody>
                    </table>`,
        id: 4
        },
        {
        src: require('@/assets/img/xinnengyuan5.png'),
        alt: 'J6P 6×4 新能源换电牵引',
        caption: `<table id="container" border="1" cellpadding="0" cellspacing="0"  style="margin: 0 auto;">
                                                     <thead>
                            <tr>
                                <th>车型描述</th>
                                <th>电机型号</th>
                                <th>后桥</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td data-label="车型描述" rowspan="3">J6P 6×4 新能源换电牵引</td>
                                <td data-label="电机型号" rowspan="3">中车TZ400XS035电机</td>
                                <td data-label="后桥">∮457</td>
                            </tr>
                             <tr>
                                <td data-label="后桥">∮457</td>
                            </tr>
                             <tr>
                                <td data-label="后桥">ф300轮减桥</td>
                            </tr>

                            </tbody>

                            <thead>
                            <tr>
                                <th>总重</th>
                                <th>马力</th>
                                <th>后桥速比</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td data-label="总重" rowspan="3">49</td>
                                <td data-label="马力" rowspan="3">489</td>
                                <td data-label="后桥速比">3.727</td>
                            </tr>
                            <tr>
                                <td data-label="后桥速比">4.875</td>
                            </tr>
                            <tr>
                                <td data-label="后桥速比">6.733</td>
                            </tr>
                            </tbody>

                            <thead>
                            <tr>
                                <th>平台</th>
                                <th>变速箱</th>
                                <th>轴距</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td data-label="平台">J6P</td>
                                <td data-label="变速箱">CA12TAX230E(AMT）</td>
                                <td data-label="轴距">3800+1350</td>
                            </tr>
                            </tbody>

                            <thead>
                            <tr>
                                <th>车架</th>
                                <th>轮胎</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td data-label="车架">300×80×8</td>
                                <td data-label="轮胎" rowspan="3">12R22.5型18层级</td>
                            </tr>
                            <tr>
                            <td data-label="车架">300×80×(8+5)</td>
                            </tr>
                            <tr>
                            <td data-label="车架">300×80×(8+8+5)</td>
                            </tr>
                            </tbody>
                    </table>`,
        id: 5
        }
    ]
    };
},
mounted() {
    // 从路由参数中获取当前详情页的id
    const id = parseInt(this.$route.params.id);
    // 根据id匹配对应的图片数据
    this.currentImage = this.images.find(image => image.id === id) || null;
}
};
</script>




// WEBPACK FOOTER //
// src/view/NewEnergyDetail.vue